import {
  List,
  TextField,
  EmailField,
  EditButton,
  FunctionField,
  Filter,
  TextInput,
  TopToolbar,
  SelectColumnsButton,
  CreateButton,
  ExportButton,
  DatagridConfigurable,
  Button,
  SelectInput,
  WrapperField,
  DateField,
  DateInput,
} from "react-admin";
import PreviewIcon from "@mui/icons-material/Preview";
import { Link } from "react-router-dom";
import { brandChoises } from "../interfaces";

const ClientFilter: React.FC = (props) => (
  <Filter {...props}>
    <TextInput label="Code interne" source="internalCode" alwaysOn />
    <TextInput label="Nom du client" source="name" alwaysOn />
    <SelectInput
      source="brand"
      choices={brandChoises}
      alwaysOn
      label="Marque"
    />
    <TextInput label="Adress" source="address" alwaysOn />
    <TextInput label="Code postal" source="zipCode" alwaysOn />
    <TextInput label="Ville" source="city" alwaysOn />
    <TextInput label="Courriel" source="email" alwaysOn />
    <TextInput label="SIRET" source="siret" alwaysOn />
    <DateInput source="startDateCreatedAt" label="D. début (création clt)" alwaysOn />
    <DateInput source="endDateLastCreatedAt" label="D. fin (création clt)" alwaysOn />
  </Filter>
);

const ListActions = () => (
  <TopToolbar>
    <SelectColumnsButton />
    <CreateButton />
    <ExportButton />
  </TopToolbar>
);

export const ClientList = () => (
  <List
    resource="clients"
    actions={<ListActions />}
    filters={<ClientFilter />}
    title="Liste des clients"
    sort={{ field: "createdAt", order: "DESC" }}
  >
    <DatagridConfigurable rowClick={false}>
      <TextField source="internalCode" label="Code interne" />
      <TextField source="name" label="Nom" />
      <TextField source="address" label="Adresse" />
      <TextField source="zipCode" label="Code postal" />
      <TextField source="city" label="Ville" />
      <EmailField source="email" label="Courriel" />
      <TextField source="siret" label="SIRET" />
      <TextField source="brand" label="Marque" />
      <TextField source="contactName" label="Contact" />
      <TextField source="phone" label="Téléphone" />
      <DateField
        source="createdAt"
        textAlign="center"
        label="D. de creation clt"
        locales="fr-FR"
        options={{
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
          hour: "2-digit",
          minute: "2-digit",
        }}
      />
      <WrapperField label="Actions">
        <EditButton />
      </WrapperField>
      <FunctionField
        label="Inventaire"
        render={(record) => (
          <Button
            component={Link}
            label="Voir"
            to={`/client-inventory/details/${record.id}`}
            variant="text"
            size="small"
            onClick={(e) => {
              e.stopPropagation();
            }}
          >
            <PreviewIcon />
          </Button>
        )}
      />
    </DatagridConfigurable>
  </List>
);
